import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { logError } from "../lib/logger";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Oturum httpOnly çerezde tutulur; açılışta çerezle /auth/me sorgulanır.
  // Test (preview) ortamında AUTO_LOGIN_EMAIL tanımlıysa şifresiz otomatik giriş denenir.
  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(async () => {
        try {
          const res = await api.post("/auth/auto-login");
          setUser(res.data.user);
        } catch {
          setUser(null);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    // Sunucu, oturumu httpOnly çerez olarak set eder — token localStorage'a YAZILMAZ.
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout"); // sunucu çerezi temizler
    } catch (err) {
      logError("Çıkış isteği başarısız:", err);
    }
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
